const state = {
  mailToBeSent: false,

  mailData: {
    title: "",
    text: "",
    url: "",
  },
};

const mutations = {
  mailToBeSentMutation: (state, payload) => {
    state.mailToBeSent = payload;
  },

  mailDataMutation: (state, payload) => {
    state.mailData = payload;
  },
};

const actions = {
  mailToBeSentAction: ({ commit }, payload) => {
    commit("mailToBeSentMutation", payload);
  },

  mailDataAction: ({ commit }, payload) => {
    commit("mailDataMutation", payload);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
